module.exports = __webpack_public_path__ + "img/paraguay.6d2f1a4.webp";